<template>
  <v-card flat>
    <v-alert
      v-if="alertMsg.status"
      :timeout="alertMsg.timeout"
      :color="alertMsg.color"
      :type="alertMsg.type"
      dismissible
    >
      {{ alertMsg.text }}
    </v-alert>
    <v-card-title class="pa-2 ma-0">
      <span class="text-h6">{{ $t("individual_share_holder") }}</span>
    </v-card-title>
    <v-divider class="p-0 m-0"></v-divider>
    <v-card-text>
      <v-container>
        <v-form v-model="valid" ref="busApplicant">
          <v-row>
            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0"
                >{{ $t("fullName") }}<span style="color: #f00">*</span></label
              >
              <v-text-field
                v-model="editedItem.full_name"
                :rules="validations.firstnameValidations"
                dense
                :placeholder="$t('fullName')"
                outlined
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0">{{ $t("Gender") }}</label>
              <v-autocomplete
                :placeholder="$t('gender_placeholder')"
                :items="genderOptions"
                v-model="editedItem.gender"
                dense
                outlined
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0">{{
                $t("date_of_birth_business")
              }}</label>

              <v-menu
                ref="dobmenu"
                v-model="dobmenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                :offset-x="true"
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="editedItem.dob"
                    persistent-hint
                    clearable
                    v-on="on"
                    type="date"
                    dense
                    @change="ValidateAge"
                    :min="minDate"
                    :max="maxDate"
                    outlined
                  >
                  </v-text-field>
                </template>
              </v-menu>
            </v-col>

            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0">{{
                $t("country_of_birth_business")
              }}</label>
              <v-autocomplete
                :placeholder="$t('country_of_birth_placeholder')"
                :items="country_options"
                item-text="name"
                item-value="id"
                v-model="editedItem.country_code"
                outlined
                required
                dense
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0"
                >{{ $t("Nationality")
                }}<span style="color: #f00">*</span></label
              >
              <v-autocomplete
                :placeholder="$t('nationality_placeholder')"
                dense
                v-model="editedItem.nationality_code"
                :items="nationality_options"
                item-text="name"
                item-value="id"
                :rules="validations.nationalityValidations"
                outlined
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0"
                >{{ $t("Occupation") }}<span style="color: #f00">*</span></label
              >
              <v-autocomplete
                v-model="editedItem.occupation_code"
                :items="occupation_options"
                item-text="name"
                item-value="id"
                :rules="validations.occupationValidations"
                :placeholder="$t('occupation_placeholder')"
                dense
                outlined
                required
              ></v-autocomplete>
            </v-col>
            <!-- <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0"
                >{{ $t("designation_label")
                }}<span style="color: #f00">*</span></label
              >
              <v-autocomplete
                v-model="editedItem.occupation_code"
                :items="occupation_options"
                item-text="name"
                item-value="id"
                :error-messages="designationErrors"
                @input="$v.editedItem.occupation_code.$touch()"
                :placeholder="$t('designation_label')"
                dense
                outlined
                required
              ></v-autocomplete>
            </v-col> -->

            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0"
                >{{ $t("emailAddress")
                }}<span style="color: #f00">*</span></label
              >
              <v-text-field
                v-model="editedItem.email_id"
                :rules="validations.emailValidations"
                :placeholder="$t('email_placeholder')"
                dense
                outlined
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0">{{ $t("address_beneficary") }}</label>
              <v-text-field
                :placeholder="$t('address_beneficary')"
                outlined
                required
                dense
                v-model="editedItem.address"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0">{{ $t("phoneNumber") }}</label>
              <vue-phone-number-input
                v-digits-only
                default-country-code="MY"
                @update="onChangeNumber"
                :error="Boolean(editedItem.phone_number) && !isValidNumber"
                v-model="editedItem.phone_number"
                class=""
              />
              <span
                v-if="editedItem.phone_number && !isValidNumber"
                style="color: #ff5252; font-size: 12px"
              >
                {{ $t("invalid_phone_number") }}
              </span>
            </v-col>
            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0">{{ $t("EmployerName") }}</label>
              <v-text-field
                :placeholder="$t('EmployerName')"
                outlined
                required
                dense
                v-model="editedItem.employer"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <label class="ma-0 pa-0"
                >{{ $t("share_holder_percentage")
                }}<span style="color: #f00">*</span></label
              >
              <v-text-field
                :placeholder="$t('share_holder_percentage')"
                v-model="editedItem.percentage_of_shares"
                suffix="%"
                type="number"
                :rules="validations.sharesRules"
                outlined
                required
                hide-spin-buttons
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <label class="ma-0 pa-0"
                >{{ $t("no_of_shares")
                }}<span style="color: #f00">*</span></label
              >
              <v-text-field
                :placeholder="$t('no_of_shares')"
                v-model="editedItem.no_of_shares"
                type="number"
                step="1"
                :rules="validations.NoofsharesRules"
                outlined
                required
                hide-spin-buttons
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0"
                >{{ $t("idType") }}<span style="color: #f00">*</span></label
              >
              <v-select
                v-model="editedItem.id_type_code"
                :menu-props="{ bottom: true, offsetY: true }"
                :rules="validations.id_proofrules"
                :items="idtypes_val"
                item-text="name"
                item-value="id"
                outlined
                required
                :placeholder="$t('idtype_select_placeholder')"
                dense
              ></v-select>
              <!-- <v-select
                    v-else
                    v-model="id_type_back"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :rules="validations.id_proofrules"
                    :items="idtypes_val"
                    item-text="name"
                    item-value="id"
                    :disabled="disableValues || disableBystatus"
                    outlined
                    required
                    :placeholder="$t('idtype_select_placeholder')"
                    dense
                  ></v-select> -->
            </v-col>

            <v-col v-if="!isMykad" cols="12" md="6">
              <label class="ma-0 pa-0"
                >{{ $t("isuueDate") }}<span style="color: #f00">*</span></label
              >
              <v-text-field
                v-model="editedItem.id_issue_date"
                :rules="validations.issuedaterules"
                dense
                required
                outlined
                type="date"
                :max="currentDate"
              />
            </v-col>
            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0"
                >{{ $t("Location")
                }}<span
                  v-if="isPassportType(editedItem.id_type_code)"
                  style="color: #f00"
                  >*</span
                ></label
              >
              <v-autocomplete
                v-model="editedItem.id_issue_country"
                item-text="name"
                item-value="id"
                :items="country_options"
                :rules="validations.issue_locationRules"
                :placeholder="$t('Location')"
                dense
                outlined
                required
                :min="currentDate"
              />
            </v-col>

            <v-col cols="12" md="6" v-if="!isMykad">
              <label class="ma-0 pa-0"
                >{{ $t("expiryDate") }}<span style="color: #f00">*</span></label
              >
              <v-text-field
                v-model="editedItem.id_expiry_date"
                :rules="validations.expDateRules"
                dense
                outlined
                required
                type="date"
                :min="currentDate"
              />
            </v-col>

            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0"
                >{{ $t("idNumber") }}<span style="color: #f00">*</span></label
              >
              <v-text-field
                v-model="editedItem.id_number"
                :rules="validations.id_numberRules"
                :placeholder="$t('id_number_placeholder')"
                outlined
                required
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0"
                >{{ $t("IDFirstPage")
                }}<span style="color: #f00">*</span></label
              >
              <v-file-input
                v-model="editedItem.ID_First_Page"
                :rules="validations.firstpage_rules"
                dense
                accept="image/png, image/jpeg, image/bmp"
                :placeholder="$t('idtype_first_page_placeholder')"
                outlined
                ref="idfirstfile"
                required
                prepend-icon=""
              >
                <template v-slot:append>
                  <v-icon
                    aria-hidden="false"
                    class="color-primary"
                    @click="openIdfirst"
                  >
                    mdi-cloud-upload
                  </v-icon>
                </template>

                <template v-slot:append-outer>
                  <v-img
                    v-if="frontPageUrl && editedItem.ID_First_Page"
                    class="ml-1"
                    max-height="40"
                    max-width="50"
                    :src="frontPageUrl"
                    @click="handleImageViewer(frontPageUrl)"
                  />
                </template>
              </v-file-input>
            </v-col>

            <v-col cols="12" md="6" class="pt-0">
              <label class="ma-0 pa-0">{{ $t("IDLastPage") }}</label>
              <v-file-input
                v-model="editedItem.ID_Last_Page"
                dense
                accept="image/png, image/jpeg, image/bmp"
                :placeholder="$t('idtype_last_page_placeholder')"
                outlined
                ref="idlastfile"
                required
                prepend-icon=""
              >
                <template v-slot:append>
                  <v-icon
                    aria-hidden="false"
                    class="color-primary"
                    @click="openIdlast"
                  >
                    mdi-cloud-upload
                  </v-icon>
                </template>

                <template v-slot:append-outer>
                  <v-img
                    v-if="backPageUrl && editedItem.ID_Last_Page"
                    class="ml-1"
                    max-height="40"
                    max-width="50"
                    :src="backPageUrl"
                    @click="handleImageViewer(backPageUrl)"
                  />
                </template>
              </v-file-input>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-divider class="p-o m-0"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        outlined
        @click="close" :disabled="isSaving"
        v-if="!editedItem.biz_user_id"
      >
        {{ $t("cancel_label") }}
      </v-btn>
      <v-btn
        color="primary"
        @click="onClickNext()" :loading="isSaving" :disabled="isSaving"
        v-if="!editedItem.biz_user_id"
        >{{ $t("save") }}</v-btn
      >
      <v-btn
        color="primary"
        outlined
        @click="close" :disabled="isSaving"
        v-if="editedItem.biz_user_id"
      >
        {{ $t("cancel_label") }}
      </v-btn>
      <v-btn color="primary" @click="update()" :loading="isSaving" :disabled="isSaving" v-if="editedItem.biz_user_id">
        {{ $t("update_label") }}</v-btn
      >
    </v-card-actions>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '435',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import { i18n as $ } from "../../../locale/index";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { email, required } from "vuelidate/lib/validators";
import { findDatePrevious } from "../../../utils/helper";
import { alpha } from "../../../utils/validate";
import { BusUserTypes } from "../../../utils/BusDocuments";
import validatemixin from "@/mixins/Busvalidate.mixin";
import imageViewer from "../../tools/imageViewer.vue";
import handleImageUpload from "../../../mixins/compressImage.mixin";
import commonService from "@/services/AgentCommonService/commonService.js";
import AgentService from "@/services/agentService/AgentService";
import alerts from "@/mixins/alerts";
import digitsOnly from "@/directives/digitsOnly";
export default {
  directives: { digitsOnly },
  mixins: [validatemixin, handleImageUpload, alerts],
  data: () => ({
    id_type: "",
    dialog: false,
    valid: true,
    currentDate: new Date().toJSON().split("T")[0],
    buscheckboxes: BusUserTypes(),
    Entitycheckbox: [],
    validationFields: [],
    backPageUrl: null,
    frontPageUrl: null,
    dialogDelete: false,
    dobmenu: false,
    kycStatus: null,
    disableBystatus: null,
    id_type_back: null,
    issue_location: null,
    maxDate: "",
    minDate: "",
    isDobError: false,
    expriydate: false,
    isValidNumber: false,
    country_options: [],
    relation_options: [],
    idtypes: [],
    idtypes_val: [],
    idtype_objs: [],
    nationality_options: [],
    occupation_options: [],
    occupation_objs: [],
    genderOptions: [
      { text: "Male", value: "M" },
      { text: "Female", value: "F" },
    ],
    isSubmitted: false,
    isUploading: false,
    isSaving: false,
    loader: false,
    alertMsg: {
      status: false,
      text: "",
      timeout: 2000,
      color: "blue-grey",
      type: "info",
    },
    countrySelected: {},
    headers: [
      {
        text: "Full Name",
        align: "start",
        sortable: false,
        value: "full_name",
      },
      { text: "Type", value: "type" },
      { text: "Email", value: "email_id" },
      { text: "ID type", value: "id_type_code" },
      { text: "ID number", value: "id_number" },
      { text: "First page", value: "first_page" },
      { text: "Last page", value: "last_page" },
      { text: "Actions", value: "actions" },
    ],
    getinformation: [],
    editedIndex: -1,
    biz_user_id: "",
    imageViewerUrl: "",
    isImageViewer: false,
    userId: null,
    editedItem: {
      full_name: "",
      gender: "",
      dob: null,
      email_id: "",
      phone_number: "",
      nationality_code: "",
      occupation_code: "",
      country_code: "",
      address: "",
      employer: "",
      percentage_of_shares: null,
      type: "Shareholder",
      // applicant_country_code: "",
      id_type_code: null,
      id_number: null,
      ID_First_Page: null,
      ID_Last_Page: null,
      no_of_shares: null,
      id_issue_date: null,
      id_expiry_date: null,
      id_issue_country: "Malaysia",
    },
    deleteId: "",
    validations: {
      emailValidations: [
        (v) => !!v || $.t("email_errors"),
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          $.t("invalid_email"),
      ],
      firstnameValidations: [
        (v) => !!v || $.t("full_name"),
        (v) => /^([a-zA-Z]+\s?)*$/.test(v) || $.t("invalid_full_name"),
      ],
      nationalityValidations: [(v) => !!v || $.t("nationalityMsg1")],
      occupationValidations: [(v) => !!v || $.t("select_occupation")],
      selfy_rules: [(v) => !!v || $.t("file_select_placeholder")],
      firstpage_rules: [(v) => !!v || $.t("file_select_placeholder")],
      issuedaterules: [
        (v) => !!v || $.t("issueDateMsg1"),
        (v) => !v || v <= new Date().toJSON().split("T")[0] || $.t("issue_date_valid"),
      ],
      issue_locationRules: [],
      expDateRules: [
        (v) => !!v || $.t("expiryDateMsg1"),
        (v) => !v || v > new Date().toJSON().split("T")[0] || $.t("expiry_date_issue_validate"),
      ],
      id_proofrules: [(v) => !!v || $.t("idtypeMsg1")],
      id_numberRules: [(v) => !!v || $.t("idnumberMsg1")],
      interviewData: [(v) => !!v || $.t("interviewDate")],
      interviewTime: [(v) => !!v || $.t("interviewTime")],
      sharesRules: [
        (v) => !!v || $.t("shares_percentage"),
        (v) => v <= 100 || $.t("no_ofsharesmsg"),
      ],
      NoofsharesRules: [
        (v) => !!v || $.t("no_ofshares"),
      ],
    },
  }),
  name: "BasicDetails",
  components: {
    VuePhoneNumberInput,
    imageViewer,
  },
  props: {
    selctedEntity: {
      type: String,
    },
  },
  computed: {
    isMykad() {
      return String(this.editedItem.id_type_code) === "1";
    },
    ...mapGetters("Transactional", [
      "realtion_list",
      "nationality_list",
      "occupation_list",
    ]),
    ...mapGetters("Authentication", ["country_list"]),
    applicantErrors() {
      const errors = [];
      if (!this.$v.editedItem.applicant_type.$dirty) return errors;
      !this.$v.editedItem.applicant_type.required && errors.push("required");
      return errors;
    },
    fnameErrors() {
      const errors = [];
      if (!this.$v.editedItem.full_name.$dirty) return errors;
      !this.$v.editedItem.full_name.required &&
        errors.push(this.$t("full_name"));
      !this.$v.editedItem.full_name.alpha &&
        errors.push(this.$t("invalid_full_name"));
      return errors;
    },

    designationErrors() {
      const errors = [];
      if (!this.$v.editedItem.occupation_code.$dirty) return errors;
      !this.$v.editedItem.occupation_code.required &&
        errors.push(this.$t("select_occupation"));
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.editedItem.email_id.$dirty) return errors;
      !this.$v.editedItem.email_id.required &&
        errors.push(this.$t("email_errors"));
      !this.$v.editedItem.email_id.email &&
        errors.push(this.$t("invalid_email"));
      return errors;
    },

    nationalityErrors() {
      const errors = [];
      if (!this.$v.editedItem.nationality_code.$dirty) return errors;
      !this.$v.editedItem.nationality_code.required &&
        errors.push(this.$t("nationality"));
      return errors;
    },

    DOBerrors() {
      const errors = [];
      if (!this.$v.editedItem.dob.$dirty) return errors;
      !this.$v.editedItem.dob.required && errors.push(this.$t("select_dob"));
      if (this.isDobError) {
        errors.push(this.$t("invalid_dob"));
      }
      return errors;
    },
  },

  watch: {
    isMykad: "clearMykadDates",
    "editedItem.id_issue_date": "clearMykadDates",
    "editedItem.id_expiry_date": "clearMykadDates",
    "editedItem.applicant_type"(applicant_type) {
      console.log("applicant_type", applicant_type);
      this.validationFields = [...this.getRequired(applicant_type)];
      console.log("applicant_type:", this.getRequired(applicant_type));
    },

    "editedItem.id_type"(val) {
      this.idtype_objs.map((i) => {
        if (val === i.parameter_value) {
          this.id_type_code = i.parameter_code;
        }
      });
    },
    "editedItem.id_type_code"(val) {
      this.handleIdTypeChange(val);
    },

    id_type(val) {
      this.idtype_objs.map((i) => {
        if (val === i.value) {
          this.id_type_code = i.id;
        }
      });
      if (val == "MYKAD" || val == "MyPR") {
        this.editedItem.id_issue_country = "Malaysia";
        this.disableIssueLoc = true;
      } else {
        // this.user_details.issue_location = "";
        this.disableIssueLoc = false;
      }
      if (val === "Passport") {
        this.validations.issue_locationRules = [
          (v) => !!v || $.t("issue_location_placeholder"),
        ];
      } else {
        this.validations.issue_locationRules = [];
      }
    },

    "editedItem.issue_location"(val) {
      this.country_objs.map((i) => {
        if (val === i.name) {
          this.issue_location_code = i.iso3;
        }
      });
    },


    countrySelected(newVal) {
      console.log("Selected country", newVal);
      if (Object.keys(newVal).length > 0) {
        this.editedItem.country_code = newVal.name;
        this.editedItem.applicant_country_code = newVal.iso3;
      }
    },
  },

  created() {
    // this.initialize();
  },
  validations() {
    return {
      editedItem: {
        applicant_type: {
          required,
        },
        full_name: {
          required,
          alpha,
        },
        nationality_code: {
          required,
        },
        occupation_code: {
          required,
        },
        email_id: {
          required,
          email,
        },
      },
    };
  },
  async mounted() {
    await this.getOccupation();
    await this.getNationalityList();
    await this.getidtypes();
    this.maxDate = findDatePrevious(new Date(), 18);
    this.minDate = findDatePrevious(new Date(), 70);
  },

  methods: {
    clearMykadDates() {
      if (this.isMykad) {
        this.editedItem.id_issue_date = null;
        this.editedItem.id_expiry_date = null;
      }
    },
    isPassportType(idTypeCode) {
      return String(idTypeCode) === "4";
    },
    handleIdTypeChange(idTypeCode) {
      const normalizedCode = String(idTypeCode || "");

      if (normalizedCode === "1") {
        this.editedItem.id_expiry_date = null;
      }

      if (normalizedCode === "1" || normalizedCode === "2") {
        this.editedItem.id_issue_country = "MYS";
        this.disableIssueLoc = true;
      } else {
        this.disableIssueLoc = false;
      }

      this.validations.issue_locationRules = this.isPassportType(idTypeCode)
        ? [(v) => !!v || $.t("issue_location_placeholder")]
        : [];
    },
    close() {
      this.$emit("closeDialog", false);
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },
    async getOccupation() {
      try {
        const responseData = await commonService.getparameterdropdowns("OCC", "IND");
        if (responseData.data.status_code === 200) {
          this.occupation_options = responseData.data.data.map((i) => {
            this.occupation_objs.push(i);
            return {
              name: i.value,
              id: i.value_code,
            };
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    async fileUpload(fileObject, biz_user_id, doc_type) {
      // Existing document URLs and empty optional fields do not need uploading.
      if (!(fileObject instanceof Blob)) return;
      const compressedFile = await this.handleImageUpload(fileObject);
      if (!compressedFile) throw new Error("Unable to prepare the selected document");
      const fileData = new FormData();
      fileData.append("document", compressedFile);
      const response = await AgentService.UploadApplicantFiles(fileData, {
        login_id: this.$route.query.login_id,
        customer_id: this.$route.query.customer_id,
        biz_user_id,
        doc_type,
      });
      if (!(response?.data?.success === true || Number(response?.data?.status_code) === 200)) {
        throw new Error(response?.data?.message || "Document upload failed");
      }
    },
    async getidtypes() {
      try {
        const responseData = await commonService.getparameterdropdowns("DOC", "IND");
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((idtype) => {
            this.idtypes.push(idtype.value);
            this.idtypes_val.push({
              name: idtype.value,
              id: idtype.value_code,
            });
            this.idtype_objs.push(idtype);
          });
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    open() {
      this.$refs.selfiefile.$el.querySelector("input").click();
    },
    openIdlast() {
      this.$refs.idlastfile.$el.querySelector("input").click();
    },
    openIdfirst() {
      this.$refs.idfirstfile.$el.querySelector("input").click();
    },
    ValidateAge(value) {
      if (!value) this.isDobError = false;
      else this.isDobError = !(value <= this.maxDate && value >= this.minDate);
    },
    onChangeNumber(e) {
      this.isValidNumber = Boolean(e && e.isValid);
    },
    async getNationalityList() {
      try {
        const responseData = await commonService.getCountryBirthList();
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((i) => {
            this.country_options.push({
              name: i.country_name,
              id: i.iso_alpha3,
            });
            this.nationality_options.push({
              name: i.nationality,
              id: i.iso_alpha3,
            });
          });
        }

        console.log("countrys", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    editItem(item) {
      this.editedIndex = this.getinformation.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.applicant_type = item.type;
      console.log("image data", item.type);
      this.idtype_objs.map((ele) => {
        console.log("ele", ele);
        if (ele.value == item.id_type_code) {
          this.editedItem.id_type_code = ele.value_code;
        }
      });
      this.editedItem.ID_First_Page = item.first_page
        ? {
            name: item.first_page?.split("/").pop(),
            value: item.first_page,
          }
        : null;

      this.editedItem.ID_Last_Page = item.last_page
        ? {
            name: item.last_page?.split("/").pop(),
            value: item.last_page,
          }
        : null;
      this.backPageUrl = item.last_page ? item.last_page : null;
      this.frontPageUrl = item.first_page ? item.first_page : null;
      this.editedItem.occupation_code = item.occupation_code
        ? item.occupation_code
        : null;
      // this.getapplicant();
      this.dialog = true;
    },
    deleteItem(item) {
      this.dialogDelete = true;
      this.deleteId = item.biz_user_id;
    },
    onClickNext() {
      // console.log(`editedItem: ${JSON.stringify(this.editedItem)}`);
      // this.$v.$touch();
      // if (this.$v.$invalid && this.$refs.busApplicant.validate()) {
      //   return;
      // }
      if (this.$refs.busApplicant.validate()) {
        return this.save();
      }
    },
    onClickBack() {
      this.$emit("onClickBack");
    },
    save() {
      return this.persistApplicant(Boolean(this.editedItem.biz_user_id));
    },
    update() {
      if (this.isSaving) return;
      if (this.$refs.busApplicant.validate()) {
        return this.updateData();
      }
    },
    updateData() {
      return this.persistApplicant(true);
    },
    async persistApplicant(isUpdate) {
      if (this.isSaving) return;
      this.isSaving = true;
      this.loader = true;
      this.clearMykadDates();
      this.alertMsg.status = false;
      let informationSaved = false;
      this.editedItem.no_of_shares = +this.editedItem.no_of_shares;
      this.editedItem.percentage_of_shares = +this.editedItem.percentage_of_shares;
      try {
        const params = {
          login_id: this.$route.query.login_id,
          customer_id: this.$route.query.customer_id,
        };
        const response = isUpdate
          ? await AgentService.updateAuthorizedIndInfo(this.editedItem, {
              ...params,
              biz_user_id: this.editedItem.biz_user_id,
            })
          : await AgentService.addAuthorizedIndInfo(this.editedItem, params);
        const result = response?.data;
        if (!(result?.success === true || Number(result?.status_code) === 200)) {
          throw new Error(result?.message || "Please try again.");
        }
        const savedData = Array.isArray(result.data) ? result.data[0] : result.data;
        this.userId = savedData?.biz_user_id || this.editedItem.biz_user_id;
        if (!this.userId) throw new Error("The saved record ID is missing. Please refresh the list.");
        this.$set(this.editedItem, "biz_user_id", this.userId);
        informationSaved = true;
        await this.fileUpload(this.editedItem.ID_First_Page, this.userId, "ID_First_Page");
        await this.fileUpload(this.editedItem.ID_Last_Page, this.userId, "ID_Last_Page");
        this.$emit("getapplicant");
        this.alertMsg.status = true;
        this.alertMsg.text = result.message;
        this.alertMsg.type = "success";
        this.alertMsg.color = "green";
        this.close();
      } catch (error) {
        this.alertMsg.status = true;
        this.alertMsg.text = informationSaved
          ? "Information saved, but documents could not be uploaded. Please retry Update: " + error.message
          : (isUpdate ? "Update" : "Creation") + " Failed: " + (error.response?.data?.message || error.message || "Please try again.");
        this.alertMsg.type = "error";
        this.alertMsg.color = "error";
      } finally {
        this.isSaving = false;
        this.loader = false;
      }
    },
  },
};
</script>
<style>
.v-input .v-label {
  margin-bottom: 0px !important;
}
</style>
